import { Badge } from "../components/ui/badge";
import { Card, CardContent } from "../components/ui/card";
import { Users, Target, Award, Clock } from "lucide-react";

const About = () => {
  const stats = [
    { icon: Users, label: "Happy Customers", value: "5,000+" },
    { icon: Target, label: "Projects Completed", value: "8,500+" },
    { icon: Award, label: "Years Experience", value: "15+" },
    { icon: Clock, label: "MW Installed", value: "2,000+" }
  ];

  const values = [
    {
      title: "Quality First",
      description: "We use only premium components and follow strict quality standards in every installation."
    },
    {
      title: "Expert Team",
      description: "Our certified technicians have extensive experience in solar panel installation and maintenance."
    },
    {
      title: "Customer Focus",
      description: "We prioritize customer satisfaction and provide ongoing support throughout your solar journey."
    },
    {
      title: "Innovation",
      description: "We stay at the forefront of solar technology to offer the most efficient solutions available."
    }
  ];

  return (
    <section id="about" className="py-20 bg-background">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <Badge variant="outline" className="mb-4 border-secondary text-secondary">
            About Us
          </Badge>
          <h2 className="text-4xl lg:text-5xl font-bold mb-6 bg-gradient-solar bg-clip-text text-transparent">
            Leading the Solar Revolution
          </h2>
          <p className="text-xl text-muted-foreground max-w-3xl mx-auto leading-relaxed">
            At PASAT COMPANY, we're passionate about transforming how the world generates and consumes energy. 
            With over 15 years of experience, we've become a trusted partner for sustainable energy solutions.
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-16 items-center mb-20">
          <div>
            <h3 className="text-3xl font-bold mb-6 text-foreground">
              Our Mission
            </h3>
            <p className="text-lg text-muted-foreground mb-6 leading-relaxed">
              To accelerate the world's transition to sustainable energy by providing high-quality solar solutions 
              that are accessible, reliable, and cost-effective. We believe that clean energy should be available 
              to everyone, and we're committed to making that vision a reality.
            </p>
            <p className="text-lg text-muted-foreground leading-relaxed">
              Every installation we complete brings us closer to a cleaner, more sustainable future. We're not 
              just installing solar panels – we're building a better tomorrow for generations to come.
            </p>
          </div>
          
          <div className="grid grid-cols-2 gap-6">
            {stats.map((stat, index) => (
              <Card key={index} className="text-center border-0 shadow-card-solar hover:shadow-solar transition-all duration-300">
                <CardContent className="p-6">
                  <stat.icon className="h-12 w-12 text-primary mx-auto mb-4" />
                  <div className="text-3xl font-bold text-primary mb-2">{stat.value}</div>
                  <div className="text-sm text-muted-foreground">{stat.label}</div>
                </CardContent>
              </Card>
            ))}
          </div>
        </div>

        <div>
          <h3 className="text-3xl font-bold mb-12 text-center text-foreground">
            Our Core Values
          </h3>
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            {values.map((value, index) => (
              <Card key={index} className="border-0 shadow-card-solar hover:shadow-solar transition-all duration-300 hover:-translate-y-1">
                <CardContent className="p-6 text-center">
                  <div className="w-16 h-16 bg-gradient-solar rounded-full flex items-center justify-center mx-auto mb-4">
                    <div className="w-8 h-8 bg-primary-foreground rounded-full"></div>
                  </div>
                  <h4 className="text-xl font-bold mb-3 text-primary">{value.title}</h4>
                  <p className="text-muted-foreground leading-relaxed">{value.description}</p>
                </CardContent>
              </Card>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;